/**
 * Messages module translations - Tabs section
 */

const tabs = {
  message: "Message",
  documentRequests: "Document requests",
  uploadDocuments: "Upload documents",
  uploadHistory: "Upload history",
};

export default tabs;
